module.exports = __webpack_public_path__ + "img/nj.3baf9e0b.png";